import { useState } from 'react'
import Styles from './Gifs.module.scss'

import { GifsProps } from './Types'
import { useDebounce } from 'hooks/useDebounce'
import { useImagePickerContext } from '../ImagePickerContext'
import { Portal } from 'components/Portal/Portal'
import { SelectionCount } from '../SelectionCount'
import { DeselectAllButton } from '../DeselectAllButton'
import { ConfirmSelectionButton } from '../ConfirmSelectionButton'
import { LoadingState } from '../LoadingState/LoadingState'
import { ScrollContainer } from '../ScrollContainer/ScrollContainer'
import { Grid } from '../Grid/Grid'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'
import { SearchField } from '../SearchField/SearchField'
import { useGiphy } from 'hooks/queries/useGiphy'
import { useConfirm } from './useConfirm'
import { MediaFileThumbnail } from '../ImageThumbnail/MediaFileThumbnail'

const Gifs = ({ actionsContainerRef }: GifsProps) => {
  const { initialQuery, toggleSelectedImage, selectedImages } = useImagePickerContext()
  const [query, setQuery] = useState(initialQuery || '')
  const debouncedQuery = useDebounce(query, 500)
  const { data, fetchNextPage, hasNextPage } = useGiphy({ query: debouncedQuery || 'random', perPage: 24 })
  const results = (data?.pages || []).flatMap((page) => page?.data || [])

  const images = results.map((item) => ({
    url: item.images.original.url,
  }))

  const { confirm, isConfirming } = useConfirm()

  return (
    <div className={Styles.gifs} data-testid="gifs-provider">
      {actionsContainerRef && (
        <Portal container={actionsContainerRef}>
          {selectedImages.length > 0 && (
            <>
              <SelectionCount />
              <DeselectAllButton />
              <ConfirmSelectionButton onPress={confirm} isDisabled={isConfirming} />
            </>
          )}
        </Portal>
      )}
      <SearchField value={query} onChange={setQuery} />

      {images.length === 0 && <LoadingState />}

      {images.length > 0 && (
        <ScrollContainer>
          <Grid.Root>
            {images.map((image, i) => (
              <Grid.Thumbnail key={`${image.url}-${i}`}>
                <MediaFileThumbnail
                  mediaFile={image}
                  onToggleSelect={toggleSelectedImage}
                  isSelected={selectedImages.some((i) => i.url === image.url)}
                />
              </Grid.Thumbnail>
            ))}
          </Grid.Root>
          {hasNextPage && (
            <div className={Styles.infiniteLoader}>
              <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage} />
            </div>
          )}
        </ScrollContainer>
      )}
    </div>
  )
}

export { Gifs }
